import { SurveyType, FeatureNameType, FeatureSectionType } from '../utils';

import { getOnboardingType } from './utils';

import CSatSurvey from 'modules/common/components/CSatSurvey/CSatSurvey';
import { useMember } from 'modules/common/queries/member';

/**
 * Unified Onboarding CSAT Component (Formation or Takeover)
 *
 * This component shows one of two CSATs based on the member's onboarding type:
 *
 * **Formation** (SP->LLC, SP->SCorp):
 * - Question: "How satisfied are you with setting up your new business on Collective?"
 * - For members creating a new business entity
 *
 * **Takeover** (LLC->LLC, LLC->SCorp, SCorp->SCorp):
 * - Question: "How satisfied are you with transitioning your business to Collective?"
 * - For members transitioning an existing business
 *
 * Eligibility:
 * - member.stage must be 'activated' (checked here to avoid unnecessary API calls)
 * - Backend also validates eligibility and returns 204 if not eligible
 */
export default function OnboardingSetupCSAT() {
    const { data: member } = useMember();

    // Only show for activated members
    if (member?.stage !== 'activated') {
        return null;
    }

    // Determine onboarding type from usertype
    const onboardingType = getOnboardingType(member?.usertype);

    if (!onboardingType) {
        return null;
    }

    const featureName =
        onboardingType === 'formation' ? FeatureNameType.onboardingFormation : FeatureNameType.onboardingTakeover;

    return (
        <CSatSurvey
            open
            surveyType={SurveyType.feature}
            featureName={featureName}
            featureSection={FeatureSectionType.onboarding}
            otherProperties={{
                setup_flow: `onboarding_${onboardingType}`,
                scenario: 'all_setups_completed',
                onboarding_type: onboardingType,
            }}
        />
    );
}
